<script lang="ts">
  type Tab = 'all' | 'subscriptions' | 'bills' | 'dismissed';

  type Props = {
    activeTab: Tab;
    totalCount: number;
    subscriptionsCount: number;
    billsCount: number;
    dismissedCount: number;
    onTabChange: (tab: Tab) => void;
  };

  let {
    activeTab,
    totalCount,
    subscriptionsCount,
    billsCount,
    dismissedCount,
    onTabChange
  }: Props = $props();
</script>

<div class="tabs">
  <button
    class:active={activeTab === 'all'}
    onclick={() => onTabChange('all')}
  >
    All ({totalCount})
  </button>
  <button
    class:active={activeTab === 'subscriptions'}
    onclick={() => onTabChange('subscriptions')}
  >
    Subscriptions ({subscriptionsCount})
  </button>
  <button
    class:active={activeTab === 'bills'}
    onclick={() => onTabChange('bills')}
  >
    Bills ({billsCount})
  </button>
  {#if dismissedCount > 0}
    <button
      class:active={activeTab === 'dismissed'}
      onclick={() => onTabChange('dismissed')}
    >
      Dismissed ({dismissedCount})
    </button>
  {/if}
</div>

<style lang="scss">
  .tabs {
    display: flex;
    gap: var(--spacing-xs);
    margin-bottom: var(--spacing-lg);
    border-bottom: var(--border-width-medium) solid var(--color-border);

    button {
      padding: var(--spacing-sm) var(--spacing-lg);
      background: none;
      border: none;
      border-bottom: var(--border-width-medium) solid transparent;
      cursor: pointer;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-medium);
      color: var(--color-text-tertiary);
      transition: all var(--transition-fast);
      position: relative;
      bottom: -2px;

      &:hover {
        color: var(--color-text-primary);
      }

      &.active {
        color: var(--color-primary);
        border-bottom-color: var(--color-primary);
      }
    }
  }
</style>
